<div class="color-picker-container" [ngClass]="{ 'flex-layout': flexLayout }">
  @for (color of colorChoices; track $index) {
    <label class="radio-button-container">
      <input
        type="radio"
        [id]="`color${color}${id}`"
        [name]="`color${id}`"
        [value]="color"
        [checked]="initialColor === color"
        [attr.aria-label]="color"
        (change)="changeColor(color)"
      />
      <span [class]="`check-mark profile-${color}` | lowercase"></span>
    </label>
  }
</div>
